import type { UploadFile } from 'antd/es/upload/interface';
import { v4 as uuidv4 } from 'uuid';

import { File, FileKind, UploadingFile } from '../types';

import { filesCreate } from './api/files';
import { Uploader } from './api/upload';

interface Props {
  file: UploadFile;
  eventId: string;
  fileKind?: FileKind;
  parentElementId?: string;
  onProgress?: (progressObj: UploadingFile) => void;
  isPublic?: boolean;
}

export const uploadFile = async (props: Props) => {
  const {
    file,
    eventId,
    fileKind,
    parentElementId,
    onProgress,
    isPublic = false,
  } = props;

  return new Promise<string>((resolve, reject) => {
    const fileId = uuidv4();
    const uploadRequestId = uuidv4();
    const now = new Date().toISOString();

    const uploader = new Uploader({ fileId, file, isPublic });

    const files: File[] = [
      {
        elementId: fileId,
        eventId,
        fileKind,
        name: file.name.replace(/'/g, ''),
        uploadSessionId: uuidv4(),
        uploadRequestId,
        size: file.size ?? 0,
        progress: file.size ?? 0,
        parentElementId,
        progressCompleted: now,
        mediaStoreCompleted: now,
        created: now,
        modified: now,
      },
    ];

    uploader
      .onProgress(({ percentage }: { percentage: number }) => {
        const progressObj: UploadingFile = {
          id: file.uid,
          elementId: fileId,
          parentElementId,
          name: file.name,
          progress: percentage,
        };
        onProgress && onProgress(progressObj);
      })
      .onComplete(async () => {
        try {
          await filesCreate(files, isPublic);

          resolve(fileId);
        } catch (err) {
          reject(err);
        }
      })
      .onError((error: any) => {
        reject(error);
      });

    uploader.start();
  });
};
